// extracted by mini-css-extract-plugin
export default {"content":"DocumContent_content__1XADE"};